import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const AuditVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Audit",
    $_tablesAudit: [],
    $_currentAudit: [],
    $_historicAudit: [],
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200
    }
  }),
  getters: {
    allTablesAudit: (state) => state.$_tablesAudit,
    allCurrentAudit: (state) => state.$_currentAudit,
    allHistoricAudit: (state) => state.$_historicAudit,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    clearTablesAudit({ commit }) {
      commit("SET_TABLES_AUDIT", []);
    },
    clearCurrentAudit({ commit }) {
      commit("SET_CURRENT_AUDIT", []);
    },
    clearHistoricAudit({ commit }) {
      commit("SET_HISTORIC_AUDIT", []);
    },
    async getTablesAudit({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetAuditableEntities";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_TABLES_AUDIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getCurrentAudit({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_moduleApiPath +
        "/GetAuditableTableData/" +
        data.tableSchema +
        "/" +
        data.tableName;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_CURRENT_AUDIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getTableData(
      { commit, dispatch, state, rootGetters },
      { schemaName, tableName }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_moduleApiPath +
        "/GetAuditableTableData/" +
        schemaName +
        "/" +
        tableName;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getHistoricAudit({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetAuditableTableAuditData";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(actionLink, data, axiosConfig);
        commit("SET_HISTORIC_AUDIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_TABLES_AUDIT(state, value) {
      state.$_tablesAudit = value;
    },
    SET_CURRENT_AUDIT(state, value) {
      state.$_currentAudit = value;
    },
    SET_HISTORIC_AUDIT(state, value) {
      state.$_historicAudit = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default AuditVuexModule;
